import React from 'react';
import styled from 'styled-components';

import ChevronIcon from '../../../containers/assets/onboarding-chevron.png';

const Wrapper = styled.div`
  height: 80px;
  background: #ffffff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px 170px 20px 40px;
  width: 100%;
`;

const PrevButton = styled.a`
  img {
    margin-right: 5px;
  }

  &:active, &:visited, &:link {
    font-family: 'Mukta Vaani';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    color: rgba(0, 27, 59, 0.6);
    text-decoration: none;
  }

  &:hover {
    text-decoration: underline;
  }

  ${p => p.isHidden && `
    visibility: hidden;
  `}
`;

const Text = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
`;

const NextButton = styled.a`
  &:active, &:visited, &:link {
    width: 160px;
    height: 40px;
    background: #5c91f5;
    border-radius: 4px;
    text-align: center;
    line-height: 40px;

    font-family: 'Mukta Vaani';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;

    ${p => p.isHidden && `
      visibility: hidden;
    `}
  }

  &:hover {
    text-decoration: none;
  }
`;

const Pagination = ({
  goNext,
  goPrev,
  isFirstStep,
  isLastStep,
  currentStep,
  countOfSteps,
}) => (
  <Wrapper>
    <PrevButton
      href="#"
      onClick={goPrev}
      isHidden={isFirstStep}
    >
      <img src={ChevronIcon} alt="" />
      Previous
    </PrevButton>
    <Text>{currentStep}/{countOfSteps}</Text>
    <NextButton
      href="#"
      onClick={goNext}
      isHidden={isLastStep}
    >
      Next
    </NextButton>
  </Wrapper>
);

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/peer-feedback/components/pagination.js